import React from 'react';

export const Textarea = ({ 
  className = '', 
  name,
  value,
  onChange,
  placeholder = '',
  rows = 3,
  ...props 
}) => {
  return (
    <textarea 
      className={`appearance-none block w-full px-3 py-2 border border-gray-300 
        rounded-md shadow-sm placeholder-gray-400 
        focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${className}`}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      {...props}
    />
  );
};

export default Textarea; 